type DeletableStage = {
  // type does not matter, all we check is whether guard is null or not
  guard?: unknown;
};

type StageDeletability = {
  result: boolean;
  reasons: string[];
};

const IS_ONLY_STAGE = 'Cannot delete the only stage in a pipeline' as const;
const NEW_FIRST_STAGE_HAS_GUARDS =
  'Cannot delete the first stage when the next stage has a guard' as const;

export const structuralReasonSet: ReadonlySet<string> = new Set([
  IS_ONLY_STAGE,
  NEW_FIRST_STAGE_HAS_GUARDS,
]);

/**
 * Computes whether a pipeline stage can be deleted, based on the
 * stages array alone. Backend callers should layer on additional
 * checks (V2 version, active projects) that require DB access.
 */
export function computeStageDeletability(
  stages: readonly DeletableStage[],
  stageIndex: number
): StageDeletability {
  const reasons: string[] = [];

  if (stages.length <= 1) {
    reasons.push(IS_ONLY_STAGE);
  }

  if (stageIndex === 0 && !!stages[1] && stages[1].guard !== null) {
    reasons.push(NEW_FIRST_STAGE_HAS_GUARDS);
  }

  return {
    result: reasons.length === 0,
    reasons,
  };
}
